import { MID_GREEN } from '../../../colors';

export const ACTUALS_LINE_COLOR = '#7F96B5';
export const EXPECTED_LINE_COLOR = MID_GREEN;

export const STROKE_OPACITY = 1.0;
